import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getRespuestaListSuccess(respuesta) {
  return {type: types.LOAD_RESPUESTA_LIST_SUCCESS, respuesta};
}



export function getRespuestaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RespuestaApi.getRespuestaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(respuesta => {                  
                  dispatch(getRespuestaListSuccess(respuesta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getRespuestaSuccess(catalogo) {
  return {type: types.LOAD_RESPUESTA_SUCCESS, catalogo};
}

export function getRespuesta(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().RespuestaApi.getRespuesta(id, token).then(respuesta => {   
        dispatch(getRespuestaSuccess(respuesta));
        return respuesta;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(respuesta) {
  return {type: types.SAVE_RESPUESTA_SUCCESS, respuesta};
}


export function save(respuesta, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().RespuestaApi.save(respuesta, token).then(respuestaGuardado => {   
    dispatch(saveSuccess(respuestaGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getRespuestaComboSuccess(datos) {
  return {type: types.GET_RESPUESTAS_COMBO_SUCCESS, datos};
}

export function getRespuestaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().RespuestaApi.getRespuestaCombo(token).then(datos => {   
        
      dispatch(getRespuestaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(respuesta) {
  return {type: types.BORRAR_RESPUESTA_SUCCESS, respuesta};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RespuestaApi.borrar(id, token ).then(respuesta => {
               
                  dispatch(borrarSuccess(respuesta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(respuesta) {
  return {type: types.ACTIVAR_RESPUESTA_SUCCESS, respuesta};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().RespuestaApi.activar(id, token).then(respuesta => {
                  dispatch(activarSuccess(respuesta));
                  return respuesta;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_RESPUESTA, filtro};
}



